
// Estilos
import styles from './modal.module.css';

// Assets
import { IoIosClose } from 'react-icons/io';

function Modal({ title, message, onConfirm, onCancel, onClose }) {
    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <button className={styles.closeButton} onClick={onClose}>
                    <IoIosClose size={28} />
                </button>

                <h2 className={styles.title}>{title}</h2>

                <p className={styles.message}>{message}</p>

                <div className={styles.buttons}>
                    <button className={styles.cancel} onClick={onCancel}>Cancelar</button>
                    <button className={styles.confirm} onClick={onConfirm}>Confirmar</button>
                </div>
            </div>
        </div>
    );
}

export default Modal;